<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr ">
            <h2>
                {{__t('ORGANIZATIONS_LIST')}}
                <sup>
                    <span class="badge badge-warning ml-2">
                        {{ __t(this.provider_type.toUpperCase()) }}
                    </span>
                </sup>
            </h2>
            <div class="panel-toolbar">

                <button class="btn  btn-sm btn-info mr-1 shadow-0 waves-effect waves-themed"  v-if="has_head_action" v-on:click="head_action">
                    <span v-if="show_head_action_title">{{this.provider_type.toUpperCase() + __t('PROV')}}</span>  <i :class="head_action_icon"></i>
                </button>

                <button class=" btn  btn-sm btn-success shadow-0  waves-effect waves-themed"
                        v-if="has_settings"
                        v-on:click="show_base_settings">
                    {{__t('BASE')}}  <i class="fal fa-cog"></i>
                </button>
            </div>
        </div>
        <div class="panel-container show pt-3 pb-5">
            <div class="panel-content">
                <div class="pb-3" v-if="percent_add > 0">
                    <div class="percent_info">
                        {{__t('PERCENT_ADD')}}
                    </div>

                    <div class="progress progress-lg mr-3 width-sm rounded bg-warning-200" >
                        <div class="progress-bar" role="progressbar" style="width: 75%;"
                             aria-valuemax="100">{{percent_add}}
                        </div>
                    </div>
                </div>

                <b-overlay :show="is_load" rounded="sm">
                    <div class="rounded">
                        <ul class="nav-menu  mb-sm-4 mb-md-0 rounded " v-if="organizations.length > 0">
                            <li v-for="org in organizations"  v-on:click.prevent.stop="set_active(org)">
                                <a class="waves-effect waves-themed pl-1 pr-1" :class="{'active_filter':is_active_org(org)}">

                                    <strong class="dl-ref bg-success-500"  v-if="org.published">
                                        active
                                    </strong>

                                    <strong class="dl-ref bg-danger-500" v-on:click.self="set_active(org)" v-if="!org.published">
                                        {{__t('unpiblished') }}
                                    </strong>

                                    <span class="nav-link-text color-black" >
                                        {{org.title}}
                                    </span>

                                    <button class="btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed" v-on:click.prevent.stop="add_location(org)">
                                        <i class="fal fa-plus"></i>
                                    </button>
                                </a>

                            </li>
                        </ul>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "left_side_org",

    props : {
        provider_type : {
            type : String,
            default : "",
        },
        has_head_action : {
            type : Boolean,
            default :false,
        },

        has_settings : {
            type : Boolean,
            default :true,
        },

        head_action_icon : {
            type : String,
            default : "fal fa-user-lock",
        },

        show_head_action_title : {
            type : Boolean,
            default :true,
        },

        percent_add : {
            type : Number,
            default : 0
        }
    },

    data() {
        return {
            organizations: [],
            is_load : false,
        }
    },

    created() {
        //EventBus.$on('loaded_api',this.get_params);
        EventBus.$on('reload_locations',this.get_params);

        this.get_params();
    },

    methods: {

        get_params() {
            this.organizations = [];
            this.is_load = true;

            this.load_organizations().then(({data}) => {
                if (data.status === "operation_success") {
                    let orgs = data.data;
                    orgs.map(item => {
                        item.is_active = false;
                        this.organizations.push(item);
                    })
                }
                return data;
            }).then(({data}) => {
                this.is_load = false;
                this.$emit('org_loaded');

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        show_base_settings() {
            this.$emit('show_base_settings');
        },

        head_action() {
            this.$emit('head_action');
        },

        add_location(org) {
            this.$emit('create_location',org);
        },

        async load_organizations() {
            return api.post('/internal/v1/catalog/organizations');
        },

        set_active (org) {
            org.is_active = !org.is_active;
            this.$emit('org_change_state',org);
            this.organizations.map(item => {
                if(parseInt(item.id) !== parseInt(org.id)) {
                    item.is_active = false;
                }
            });
        },

        is_active_org(org) {
            return org.is_active;
        }
    }
}
</script>

<style scoped>
a.active_filter {
    border-left: 3px solid #584475;
    background: #eee;
}
</style>
